export default function ProgressRing({ day = 7, total = 21, size = 180, stroke = 6 }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.min(1, day / total);
  const offset = circ * (1 - pct);
  return (
    <div style={{ position: "relative", width: size, height: size }} data-testid="progress-ring">
      <svg width={size} height={size} className="ring-svg">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={stroke} className="ring-bg" />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          fill="none" strokeWidth={stroke} strokeLinecap="round"
          className="ring-fill"
          strokeDasharray={circ}
          strokeDashoffset={offset}
        />
      </svg>
      <div style={{
        position: "absolute", inset: 0, display: "flex",
        flexDirection: "column", alignItems: "center", justifyContent: "center",
        textAlign: "center"
      }}>
        <div className="eyebrow" style={{ marginBottom: 8 }}>Day</div>
        <div style={{ fontFamily: "var(--serif)", fontSize: "3rem", lineHeight: 1, color: "var(--charcoal)" }}>{day}</div>
        <div className="body-sm" style={{ marginTop: 6 }}>of {total}</div>
      </div>
    </div>
  );
}
